module.exports = __webpack_public_path__ + "img/127ne.e492a252.svg";